import { render } from "./GrowthCharts.vue?vue&type=template&id=23139201&scoped=true"
import script from "./GrowthCharts.vue?vue&type=script&lang=js"
export * from "./GrowthCharts.vue?vue&type=script&lang=js"

import "./GrowthCharts.vue?vue&type=style&index=0&id=23139201&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23139201"]])

export default __exports__